import { Predicate } from "@utils/predicate";
import { Action } from "./action";
import { StepEvent } from "./events";
import { StepOptionsInternal, defaultOptions } from "./stepOptionsInternal";

export type EventCallback = (step: Step) => boolean | undefined;

export type StepOptions = Partial<StepOptionsInternal>;

export class Step {
    #title: string;
    #info;
    #template: string;
    #isEnabledCallback: Predicate;
    #isValidCallback: Predicate;
    #isRequiredCallback: Predicate;
    #actions: Action[];

    #handlers: { [id: string]: EventCallback | undefined; } = {};

    get title() {
        return this.#title;
    }

    get info() {
        return this.#info;
    }

    get template() {
        return this.#template;
    }

    get isRequired() {
        return this.#isRequiredCallback();
    }

    get isEnabled() {
        return this.#isEnabledCallback();
    }

    get isValid() {
        return this.#isValidCallback();
    }

    get actions() {
        return this.#actions;
    }

    get hasActions() {
        return !!this.#actions.length;
    }

    get isTouched() {
        return true;
    }

    constructor(title: string, template: string, options: StepOptions = defaultOptions) {
        this.#title = title;
        this.#template = template;

        const normalized: StepOptionsInternal = { ...defaultOptions, ...options };

        this.#info = normalized.info;
        this.#isEnabledCallback = normalized.isEnabledCallback;
        this.#isValidCallback = normalized.isValidCallback;
        this.#isRequiredCallback = normalized.isRequiredCallback;
        this.#actions = normalized.actions;

        this.#handlers[StepEvent.Finishing] = normalized.onBeforeFinish;
    }

    handle(event: StepEvent) {
        const handler = this.#handlers[event];

        if (!handler) {
            return true;
        }

        return handler(this);
    }
}
